<template>
  <page-main
    :tableData="tableData"
    :loading="loading"
    :tablePage="page"
    @reload="reload"
  >
    <page-header
      ref="header"
      slot="header"
      @query="getData"
      @reset="resetPage"
    />
    <pagination
      size="small"
      align="right"
      slot="pager"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      @change="handlePaginationChange"
    />
  </page-main>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  components: { PageHeader, PageMain },
  mixins: [BaseTable],
  props: { orderCode: { type: String, default: '' } },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .pendingOrderExecutionLogListApi({
          orderCode: this.orderCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
